import { debounce } from 'lodash';

export default {
  data() {
    const data = {
      category: null,
      categories: [],
    };
    data.categories.allCategoriesItem = { ID: null, Name: 'All Categories' };
    data.categories.default = data.categories.allCategoriesItem;
    data.categories.byId = {};
    return data;
  },
  methods: {
    getCategories(withAll = false) {
      return withAll ? [this.categories.allCategoriesItem, ...this.categories] : this.categories;
    },
    async fetchCategories() {
      this.$startLoading('categories');

      const categories = await this.$api.projects.categories.index();
      categories.allCategoriesItem = this.categories.allCategoriesItem;
      categories.default = this.categories.default;
      categories.byId = categories.reduce((acc, category) => ({ ...acc, [category.ID]: category }), {});
      this.categories = categories;

      if (!this.category) {
        this.setCategory(this.getDefaultCategory());
      }
      this.$stopLoading('categories');
      return this.categories;
    },
    getCategory(field) {
      if (!this.category) {
        return undefined;
      }
      return field ? this.category[field] : this.category;
    },
    getCategoryBy(field, value) {
      return field === 'ID' ? this.categories.byId[value] : this.categories.find(category => category[field] === value);
    },
    setCategoryDebounce(category) {
      if (category !== this.category) {
        this.$startLoading('categories');
        this._setCategoryDebounce(category);
      }
    },
    _setCategoryDebounce: debounce(function setCategoryDebounce(category) {
      this.setCategory(category);
      this.$stopLoading('categories');
    }, 200),
    setCategory(category) {
      this.category = category;
    },
    setAllCategoriesItem(name) {
      this.categories.allCategoriesItem.Name = name;
    },
    getDefaultCategory() {
      return this.categories.default;
    },
    setDefaultCategory(category) {
      this.categories.default = category;
    },
  },
  watch: {
    category() {
      if (!this.category) {
        this.$nextTick(() => {
          this.setCategory(this.getDefaultCategory());
        });
      }
    },
  },
};
